export const CodebookForForm = {
  VALUE_AND_TYPE: 'VALUE_AND_TYPE',
  TYPE: 'TYPE',
  HIERARCHICAL: 'HIERARCHICAL',
};

//Predstavlja request ka back-u - ovakvu strukturu i kroz postman šaljemo
//TODO obrisati kada se pređe na prave podatke
export const codebookCodesDemo = {
  cities: {
    name: 'cities',
    code: 'grad',
    type: CodebookForForm.TYPE,
  },
  municipalities: {
    name: 'municipalities',
    code: 'opstina',
    type: CodebookForForm.TYPE,
  },
  streets: {
    name: 'streets',
    code: 'ulice',
    type: CodebookForForm.TYPE,
  },
  settlementZones: {
    name: 'settlementZones',
    code: 'naselja',
    type: CodebookForForm.TYPE,
  },
};

export const codebookColumnValue = {
  zipCode: {
    name: 'Poštanski broj',
  },
  municipalityZipCode: {
    name: 'Poštanski broj - opštine',
  },
  currency: {
    name: 'Naziv valute',
  },
  tariffType: {
    name: 'Tarifni tip',
    specialFeeValue: ['1', '2', '3'],
    mpiValue: ['4'],
    mpDjValue: ['5', '6'],
  },
  tariffCodeCodebook: {
    name: 'Tarifna oznaka',
  },
  tariffSubcodeCodebook: {
    name: 'Tarifna podoznaka',
  },
  codeSettlementZones: {
    name: 'Kod zone naselja',
  },
  zoneIndicator: {
    name: 'Indikator zone',
  },
};

//TODO dopuniti po potrebi - za uslovne rendere
export const CodebookCriteria = {
  BILL_USER: '1',

  LEGAL_ENTITY: '0',
  PHYSICAL_ENTITY: '1',
  KJS_ENTITY: '2',

  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',

  STATUS_ACTIVE: '1',

  // Nove vrste partnera
  BUSINESS_PARTNER_WITHOUT_PIB: 'BP', // Partner kojem nije potreban PIB
  DOMESTIC_PARTNERS: 'DOM', // Domaći kupci/dobavljači
  FOREIGN_PARTNERS: 'INO', // Inostrani kupci/dobavljači
  DOMESTIC_PARTNERS_WITH_SAME_PIB: 'DPIB', // Domaći kupci, dobavljači sa istim PIB-om

  DOMESTIC_COUNTRY_CODEBOOK: '688',

  PHYSICAL_ENTITY_PARTNER: 'FL', // Fizičko lice

  FOREIGN_SOCIETY: '8', //Ino društvo

  BUSINESS_PARTNER_ACTIVE: '1',

  PDV_RECORD_OBLIGOR: 'Obveznik na osnovu PDV evidencije',

  INVOICE_OBLIGOR: 'Obveznik na osnovu eFakture',

  YES_INDICATOR: '1',
  NO_INDICATOR: '0',

  SAFE: '0',
  MAIL: '1',
  POST: '2',

  SALE: '4',

  CONTACT_ADDRESS: '1',
  CONTACT_INVOICE: '2',
  CONTACT_COMMUNICATION: '3',
  CONTACT_SMS: '4',
  CONTACT_PHONE: '5',

  TV_SHOW: 'S',

  IN_PROCESSING: '0',

  BROADCAST_CHANNEL_INTERNET: '4',

  SPECIAL_FEE: 'PN',
  MP_PUBLISHER: 'MP-I',
  MR_DEVICE_DJ: 'MP-UDJ',
  PUBLIC_PERFORMANCE: 'JI',
  INTERNET_COMMUNICATION: 'IN',
  SATELLITE_BROADCASTING: 'SE',
  REBROADCASTING: 'RE',
  BROADCASTING: 'E',
  PUBLIC_COMMUNICATION: 'JS',

  CHARGEABLE: '0',
  NOT_CHARGEABLE: '1',

  DISPUTED_DECLARATION: '1',
  ANNULLED_DECLARATION_APPLICATION: '2',
  REPORTED_DECLARATION: '3',
  DECLARATION_IN_USE: '4',

  INTERNALLY_EMPLOYED: '1',

  CONTRACT_VERIFICATION: '1',
  VERIFIED_CONTRACT: '2',
  REJECTED_CONCLUSION_CONTRACT_ANNEX: '3',
  CONCLUDED_CONTRACT_ANNEX: '4',
  TERMINATED_CONTRACT_ANNEX: '5',
  WITHDRAWN_CONTRACT_ANNEX: '6',

  VIA_INTERMEDIARY: '1',
  WITHOUT_INTERMEDIARY: '0',

  APPLICATION_ENTRY: '0',
  USER_CONSENT: '1',
  VERIFICATION_APPLICATION: '2',
  VERIFIED_APPLICATION: '3',
  REJECTED_APPLICATION: '4',
  WITHDRAWN_APPLICATION: '5',

  ONE_TIME: '1',
  MONTHLY: '2',
  QUARTERLY: '3',
  SIX_MONTHS: '4',
  YEARLY: '5',

  INDIVIDUAL: '1',
  CONTINUOUS: '2',

  ELECTRONIC_APPLICATION_FIELD_CONTROLLER: '2',
  WRITTEN_MINUTES_FIELD_CONTROLLER: '5',
  MAIN_EVENT: '1',
  FOLLOWING_EVENT: '2',

  TRANSPORTATION_VEHICLES: 'TK11',

  CHARITY_CONCERT_YES: '0',

  CINEMA: 'TB35',
};

//TODO dopuniti/promeniti po potrebi
export const codebookCodes = {
  //Status
  statuses: {
    name: 'statuses',
    code: 'STAT',
    type: CodebookForForm.TYPE,
  },
  codebookStatuses: {
    name: 'codebookStatuses',
    code: 'STSI',
    type: CodebookForForm.TYPE,
  },
  codebookTypes: {
    name: 'codebookTypes',
    code: 'TIPS',
    type: CodebookForForm.TYPE,
  },
  //Tip Korisnika
  userTypes: {
    name: 'userTypes',
    code: 'TKSN',
    type: CodebookForForm.TYPE,
  },
  //Tip Pravnog lica
  legalEntityTypes: {
    name: 'legalEntityTypes',
    code: 'TPLK',
    type: CodebookForForm.TYPE,
  },
  //Tip Kontakta
  contactTypes: {
    name: 'contactTypes',
    code: 'TKON',
    type: CodebookForForm.TYPE,
  },
  //Način Dostave Fakture
  invoiceDeliveryTypes: {
    name: 'invoiceDeliveryTypes',
    code: 'NADF',
    type: CodebookForForm.TYPE,
  },
  //Region kome korisnik pripada ili Regionalni Koeficijent na testnom okruženju
  regions: {
    name: 'regions',
    code: 'REGK',
    type: CodebookForForm.TYPE,
  },
  //Države
  countries: {
    name: 'countries',
    code: 'DRŽA',
    type: CodebookForForm.TYPE,
  },
  kjsList: {
    name: 'kjsList',
    code: 'KJS',
    type: CodebookForForm.TYPE,
  },
  channelBroadcastingList: {
    name: 'channelBroadcastingList',
    code: 'KAEM',
    type: CodebookForForm.TYPE,
  },
  coverageList: {
    name: 'coverageList',
    code: 'POKR',
    type: CodebookForForm.TYPE,
  },
  methodFinancingList: {
    name: 'methodFinancingList',
    code: 'NAFI',
    type: CodebookForForm.TYPE,
  },
  //Vrsta internet korišćenja
  internetTypeList: {
    name: 'internetTypeList',
    code: 'VRIK',
    type: CodebookForForm.TYPE,
  },
  //Vrsta AV Zapisa
  audioVideoRecordTypes: {
    name: 'audioVideoRecordTypes',
    code: 'VAVZ',
    type: CodebookForForm.TYPE,
  },
  foreignCompanies: {
    name: 'foreignCompanies',
    code: 'NDZP',
    type: CodebookForForm.TYPE,
  },
  //Vrsta korišćenja deklaracija uređaja
  usageTypesDeviceDeclaration: {
    name: 'usageTypesDeviceDeclaration',
    code: 'VKDU',
    type: CodebookForForm.TYPE,
  },
  //Grupa proizvoda
  productGroups: {
    name: 'productGroups',
    code: 'GRPO',
    type: CodebookForForm.TYPE,
  },
  usagePeriodCodebooks: {
    name: 'usagePeriodCodebooks',
    code: 'PKOR',
    type: CodebookForForm.TYPE,
  },
  //Oznaka posebne naknade
  specialFees: {
    name: 'specialFees',
    code: 'NAPL',
    type: CodebookForForm.TYPE,
  },
  //Status zapisa podataka o paketu
  declarationStatuses: {
    name: 'declarationStatuses',
    code: 'SDEK',
    type: CodebookForForm.TYPE,
  },
  //Način emitovanja
  broadcastingTypes: {
    name: 'broadcastingTypes',
    code: 'NACE',
    type: CodebookForForm.TYPE,
  },
  //Kanali emitovanja
  broadcastChannels: {
    name: 'broadcastChannels',
    code: 'KAEM',
    type: CodebookForForm.TYPE,
  },
  //Kanali prijema
  receiptChannels: {
    name: 'receiptChannels',
    code: 'KAPR',
    type: CodebookForForm.TYPE,
  },
  //Načini finansiranja
  financingMethods: {
    name: 'financingMethods',
    code: 'NAFI',
    type: CodebookForForm.TYPE,
  },
  //Gradovi
  cities: {
    name: 'cities',
    code: 'GRAD',
    type: CodebookForForm.TYPE,
  },
  //Opštine
  municipalities: {
    name: 'municipalities',
    code: 'OPTN',
    type: CodebookForForm.TYPE,
  },
  //Ulice
  streets: {
    name: 'streets',
    code: 'ULIC',
    type: CodebookForForm.TYPE,
  },
  //Naseljena mesta
  settlementZones: {
    name: 'settlementZones',
    code: 'NAME',
    type: CodebookForForm.TYPE,
  },
  broadcastingMethods: {
    name: 'broadcastingMethods',
    code: 'NACE',
    type: CodebookForForm.TYPE,
  },
  digitalRecordTypeCodebookList: {
    name: 'digitalRecordTypeCodebookList',
    code: 'digRecord',
    type: CodebookForForm.TYPE,
  },
  subclassCodebookList: {
    name: 'subclassCodebookList',
    code: 'subclass',
    type: CodebookForForm.TYPE,
  },
  categoryCodebookList: {
    name: 'categoryCodebookList',
    code: 'category',
    type: CodebookForForm.TYPE,
  },
  classCodebookList: {
    name: 'classCodebookList',
    code: 'class',
    type: CodebookForForm.TYPE,
  },
  digRecTypeStatusCodebooks: {
    name: 'digRecTypeStatusCodebooks',
    code: 'STDZ',
    type: CodebookForForm.TYPE,
  },
  digRecStatusCodebooks: {
    name: 'digRecStatusCodebooks',
    code: 'SDGZ',
    type: CodebookForForm.TYPE,
  },
  //Vrsta koriscenja
  usageTypes: {
    name: 'usageTypes',
    code: 'VRKO',
    type: CodebookForForm.TYPE,
  },
  //Tip korišćenja
  typeOfUsageCodebooks: {
    name: 'typeOfUsageCodebooks',
    code: 'TKOR',
    type: CodebookForForm.TYPE,
  },
  //Način zaključenja ugovora
  contractConclusionMethod: {
    name: 'contractConclusionMethod',
    code: 'COCM',
    type: CodebookForForm.TYPE,
  },
  //Obračun provizije po ugovoru
  commissionSettlementPerContract: {
    name: 'commissionSettlementPerContract',
    code: 'CSPC',
    type: CodebookForForm.TYPE,
  },
  commissionCalculations: {
    name: 'commissionCalculations',
    code: 'CSCS',
    type: CodebookForForm.TYPE,
  },
  accountingPeriods: {
    name: 'accountingPeriods',
    code: 'POBR',
    type: CodebookForForm.TYPE,
  },
  //Status ugovora
  contractStatuses: {
    name: 'contractStatuses',
    code: 'SUGO',
    type: CodebookForForm.TYPE,
  },
  applicationStatuses: {
    name: 'applicationStatuses',
    code: 'STPR',
    type: CodebookForForm.TYPE,
  },
  tariffClasses: {
    name: 'tariffClasses',
    code: 'TAKL',
    type: CodebookForForm.TYPE,
  },
  tariffNumbers: {
    name: 'tariffNumbers',
    code: 'TABR',
    type: CodebookForForm.TYPE,
  },
  tariffSubnumbers: {
    name: 'tariffSubnumbers',
    code: 'TAPB',
    type: CodebookForForm.TYPE,
  },
  notificationCodes: {
    name: 'notificationCodes',
    code: 'ntfCode',
    type: CodebookForForm.TYPE,
  },
  symbolicAddressTypes: {
    name: 'symbolicAddressTypes',
    code: 'ntfSymbolicAddressType',
    type: CodebookForForm.TYPE,
  },
  //Vrsta potpisanog ugovora
  signedContractTypes: {
    name: 'signedContractTypes',
    code: 'VPUG',
    type: CodebookForForm.TYPE,
  },
  //Vrsta potpisanog aneksa
  signedAnnexTypes: {
    name: 'signedAnnexTypes',
    code: 'VPAN',
    type: CodebookForForm.TYPE,
  },
  businessPartnerTypes: {
    name: 'businessPartnerTypes',
    code: 'VRPP',
    type: CodebookForForm.TYPE,
  },
  businessPartnerClassTypes: {
    name: 'businessPartnerClassTypes',
    code: 'KLSK',
    type: CodebookForForm.TYPE,
  },
  settlementZonesCodebook: {
    name: 'settlementZonesCodebook',
    code: 'PNZO',
    type: CodebookForForm.TYPE,
  },
  designationSettlementZones: {
    name: 'designationSettlementZones',
    code: 'GRNA',
    type: CodebookForForm.TYPE,
  },
  areaApplicationTypes: {
    name: 'areaApplicationTypes',
    code: 'PPTG',
    type: CodebookForForm.TYPE,
  },
  connectionTypes: {
    name: 'connectionTypes',
    code: 'VRPO',
    type: CodebookForForm.TYPE,
  },
  bookGroupPartnersTypes: {
    name: 'bookGroupPartnersTypes',
    code: 'KGPA',
    type: CodebookForForm.TYPE,
  },
  documentTypes: {
    name: 'documentTypes',
    code: 'PKTD',
    type: CodebookForForm.TYPE,
  },
  eventTypes: {
    name: 'eventTypes',
    code: 'TDOG',
    type: CodebookForForm.TYPE,
  },
  charityConcert: {
    name: 'charityConcert',
    code: 'IHUK',
    type: CodebookForForm.TYPE,
  },
  businessPartnerStatuses: {
    name: 'businessPartnerStatuses',
    code: 'STPP',
    type: CodebookForForm.TYPE,
  },
  //Tip prodaje izdanja
  editionSalesTypes: {
    name: 'editionSalesTypes',
    code: 'TPRI',
    type: CodebookForForm.TYPE,
  },
  storagePeriods: {
    name: 'storagePeriods',
    code: 'ROKC',
    type: CodebookForForm.TYPE,
  },
  //Tip digitalnog servisa
  digitalServices: {
    name: 'digitalServices',
    code: 'DGTS',
    type: CodebookForForm.TYPE,
  },
};

export const digitalRecordTypeCodebooks = {
  SIGNED_CONTRACT: {
    categoryCb: 'contractCategory',
    classCb: 'contractClass',
    subclassCb: 'contractSubclass',
  },
};
